import { Box, styled } from "@mui/material";

const TABLET_LAYOUT_MEDIA_QUERY = "@media (min-width: 768px)";
const DESKTOP_LAYOUT_MEDIA_QUERY = "@media (min-width: 1200px)";

export const PageContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

export const ResultsList = styled(Box)`
  grid-area: list;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  min-height: 0;
  min-width: 0;
  width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: auto;
  padding: ${({ theme }) => theme.spacing(2, 1.5, 4)};
  background-color: ${({ theme }) => theme.palette.custom.neutral50};

  & > div {
    min-width: 0;
    width: 100%;
  }

  /* Empty / loading / error states should fill the pane and center on mobile. */
  & > [role="status"],
  & > [role="alert"] {
    flex: 1 1 auto;
  }

  /* Keep inline FAQ in view; don't let empty/error copy consume the pane. */
  & > [role="status"]:not(:last-child),
  & > [role="alert"]:not(:last-child) {
    flex: 0 0 auto;
    min-height: 0;
  }

  ${TABLET_LAYOUT_MEDIA_QUERY} {
    padding: ${({ theme }) => theme.spacing(2, 3, 4)};
  }
`;

export const MapContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isAddressEntry",
})<{ isAddressEntry?: boolean }>`
  grid-area: map;
  min-height: 0;
  height: 100%;
  position: relative;
  border-bottom: 1px solid ${({ theme }) => theme.palette.divider};
  ${({ isAddressEntry }) => isAddressEntry && `display: none;`}

  ${TABLET_LAYOUT_MEDIA_QUERY} {
    border-bottom: none;
    border-left: 1px solid ${({ theme }) => theme.palette.divider};
  }

  ${({ isAddressEntry, theme }) =>
    isAddressEntry
      ? `
    ${DESKTOP_LAYOUT_MEDIA_QUERY} {
      display: block;
      border-bottom: none;
      border-left: 1px solid ${theme.palette.divider};
    }
  `
      : ""}
`;
